// @flow
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routes from "./routes/Routes";

const App = () => {
  return (
    <>
        <Routes />
        <ToastContainer autoClose={1500}/>
    </>
  );
};

export default App;
